import { PlanningEnvironment } from '../app/interfaces/planning-environment.interface';

export const environment: PlanningEnvironment = {
  production: true,
  env: 'preprod',
  mobileUrl: 'https://preprod-planning.integrix.lu/mobile/',
  ticketAppId: 'cfb47637-ccfc-a9c2-a012-777aab224b2f',
  ticketWiAppId: 'SX.WEB.SAV.CTR',
  displayEntityId: true,
  api: {
    apiEndPoint: 'api/',
  },
  app: {
    defaultRoute: '',
    appName: 'Planning',
    appVersion: '1.6.2',
    appVersionDate: '21/09/2023',
    appId: '2937b3fc-5882-49ef-8e79-62b1a01bf97c',
    lang: ['fr'],
    cache: 0,
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-planning.integrix.lu/oauth2',
      api: 'auth-azure',
    },
  },
  login: {
    loginRoute: 'login',
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
    defaultConnection: true,
    showSettingsButton: false,
  },
  portal: {
    api: 'auth/auth-portal',
    portalUri: 'https://preprod-portail.integrix.lu',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-planning.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://changelogs.integrix.lu/api/versions?&WITH=product|=|WEB-PLAN',
    route: 'main/changelogs',
  },
  links: {
    ticket: 'https://preprod-ticket.integrix.lu/',
  },
};
